module.exports = __webpack_public_path__ + "img/hr-puberty-decal-00.42b9bcf6.png";